"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _deepCloneObject = _interopRequireDefault(require("../../helpers/deepCloneObject"));

var serializeFormValueValidity = function serializeFormValueValidity(props) {
  var validatedValues = {};
  var storedValues = props.storedValues;
  var clonedValues = (0, _deepCloneObject["default"])(storedValues);
  Object.keys(clonedValues).forEach(function (key) {
    var field = storedValues[key];
    validatedValues[field.fieldKey] = field.isValid;
  });
  return validatedValues;
};

var _default = serializeFormValueValidity;
exports["default"] = _default;